/**
 * Maximum length for a field destined to be in CRM
 */
export const CRM_MAX_FIELD_LENGTH = 4000;

export const CRM_DROPDOWN_MAX_OPTIONS = 30;

export const CRM_OTHER_DETAILS_MAX_LENGTH = 200;
